import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  skeleton: {
    '& span': {
      lineHeight: 'inherit',
      borderRadius: '3px'
    }
  }
})

export default useStyles
